var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"tabindex":"0"},on:{"click":_vm.add}},[_c('span',{class:_vm.$style.default},[_vm._v("三")]),_vm._t("default",[_vm._v("Add row")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }